import { lightColors } from '@/plugins/colors/base/baseColorsLight'

const dropdownTokensLight = {
  'dropdown-background-default': lightColors.gray.white,
  'dropdown-background-active': lightColors.gray.white,
  'dropdown-background-disabled': lightColors.gray.white,
  'dropdown-background-error': lightColors.gray.white,
  'dropdown-border-default': lightColors.gray['100'],
  'dropdown-border-active': lightColors.gray.white,
  'dropdown-border-disabled': lightColors.gray.white,
  'dropdown-border-error': lightColors.gray.white,
  'dropdown-foreground-default': lightColors.gray['300'],
  'dropdown-foreground-active': lightColors.gray.white,
  'dropdown-foreground-disabled': lightColors.gray.white,
  'dropdown-foreground-error': lightColors.gray.white,
  'dropdown-label-default': lightColors.gray['900'],
  'dropdown-label-active': lightColors.gray['900'],
  'dropdown-label-disabled': lightColors.gray.white,
  'dropdown-label-error': lightColors.gray['900'],
  'dropdown-icon': lightColors.gray['300']
}

export default dropdownTokensLight
